/** Created by azhou on 2019/3/25.*/
<template>
    <div class="mt-3">
      <div class="d-flex flex-wrap">
        <div class="d-center-start w-50 mb-3" v-for="item in activityArr" :key="item.cn">
          <left-text :leftText="item.cn"/>{{item.value}}
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'ActivityInfo',
    computed: {
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['storeInfo']),
      activityInfo() { return this.StoreBasicInfo.activityInfo || {} },
      activityArr() {
        switch (this.storeInfo.type) {
          case 2:return [
            {cn:'发布订单总数',value:`${this.activityInfo.send_count||0} 个`},
            {cn:'成功订单总额',value:`${this.$options.filters['formatMoney'](this.activityInfo.deal_price_total)} 元`},
            {cn:'预订成功数',value:`${this.activityInfo.deal_count||0} 个`},
            {cn:'实际付款总额',value:`${this.$options.filters['formatMoney'](this.activityInfo.success_order_pay / 100)} 元`},
          ];
          case 3:return [
            {cn:'最近三个月匹配',value:`${this.activityInfo.match_count||0} 次`},
            {cn:'成交订单金额',value:`${this.$options.filters['formatMoney'](this.activityInfo.deal_price_total)} 元`},
            {cn:'报价次数',value:`${this.activityInfo.offer_count	||0} 次`},
            // {cn:'实际收款金额',value:`${this.$options.filters['formatMoney'](this.activityInfo.success_order_pay / 100)} 元`},
            {cn:'成交订单数',value:`${this.activityInfo.deal_count||0} 个`},
          ];
          case 5:
          case 6:
          case 8:return [
            {cn:'收到订单数',value:`${this.activityInfo.order_total_nums} 次`},
            {cn:'成功订单总额',value:`${this.$options.filters['formatMoney'](this.activityInfo.success_order_price)} 元`},
            {cn:'预订成功数',value:`${this.activityInfo.success_order_nos} 次`},
            {cn:'实际收款总额',value:`${this.$options.filters['formatMoney'](this.activityInfo.success_order_pay / 100)} 元`},
          ];
          default:return [];
        }
      }
    }
  }
</script>
